<template>
  <q-btn
    v-bind="$attrs"
    @click="openModal"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import openModal from '@/components/modal';
import ImportsModal from './ImportsModal.vue';

export default defineComponent({
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    platform: {
      type: String,
      required: true,
    },
  },
  methods: {
    openModal() {
      const config = {
        parent: this,
        accountId: this.accountId,
        platform: this.platform,
      };
      openModal(ImportsModal, config);
    },
  },
});
</script>
